import { IUserDetails } from "models/IUserDetails";

export type ObjectiveType =
  "ai_generated" | "predefined" | "likert_scale" | "multiple_choice";

export const OBJECTIVE_TYPE_AI_GENERATED: ObjectiveType = "ai_generated";
export const OBJECTIVE_TYPE_PREDEFINED: ObjectiveType = "predefined";
export const OBJECTIVE_TYPE_LIKERT_SCALE: ObjectiveType = "likert_scale";
export const OBJECTIVE_TYPE_MULTIPLE_CHOICE: ObjectiveType = "multiple_choice";

export const OBJECTIVE_TYPE_LABEL_AI_GENERATED = "AI Generated";
export const OBJECTIVE_TYPE_LABEL_PREDEFINED = "Predefined";
export const OBJECTIVE_TYPE_LABEL_LIKERT_SCALE = "Likert Scale";
export const OBJECTIVE_TYPE_LABEL_MULTIPLE_CHOICE = "Multiple Choice";

export const MAX_PREDEFINED_QUESTIONS = 3;
export const MIN_PREDEFINED_QUESTIONS = 1;

export const MAX_MULTIPLE_CHOICE_QUESTIONS = 20;
export const MIN_MULTIPLE_CHOICE_QUESTIONS = 1;
export const MAX_MULTIPLE_CHOICE_OPTIONS = 20;
export const MIN_MULTIPLE_CHOICE_OPTIONS = 1;
export const MAX_MULTIPLE_CHOICE_OPTION_LENGTH = 100;

export const MAX_LIKERT_STATEMENTS = 10;
export const MIN_LIKERT_STATEMENTS = 1;

export const MAX_OBJECTIVE_QUESTION_LENGTH = 1024;
export const MAX_LIKERT_SCALE_LABEL_LENGTH = 100;

export const DEFAULT_LIKERT_SCALE_LABELS: Record<string, string> = {
  "1": "Strongly Disagree",
  "2": "Disagree",
  "3": "Neutral",
  "4": "Agree",
  "5": "Strongly Agree",
};

export interface IObjectiveQuestion {
  /** Client-only key for list rendering and per-question UI state; never sent to the API. */
  id?: string;
  text: string;
  required: boolean;
  options?: string[];
  /** Multiple choice only: whether several options can be selected. */
  allowMultipleSelection?: boolean;
}

export const getOptionLabel = (
  answer: string,
  labels?: Record<string, string>,
): string => {
  if (answer === "0") return "N/A";
  return labels?.[answer] ?? DEFAULT_LIKERT_SCALE_LABELS[answer] ?? answer;
};

export interface IObjective {
  questionNumber: number;
  name?: string;
  description?: string;
  sampleQuestions?: IObjectiveQuestion[];
  maxQuestions?: number;
  selectOptions?: Record<string, string>;
  text: string;
  user: IUserDetails;
  order?: number;
  objectiveType?: ObjectiveType;
  _id?: string;
  allowSkipping?: boolean;
}
